import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const HoverFlag = ({ text, abbr, inline, className }) => {
  const firstLetter = String(text).substr(0, 1);
  const abbrText = String(abbr || firstLetter).substr(0, 2);
  const composedClassName = classnames("hover-flag", className, {
    "hover-flag--inline": inline,
    "hover-flag--double-size-drop": abbrText.length > 1
  });

  return (
    <div className={composedClassName}>
      <div className="hover-flag__abbr">
        <span>{abbrText}</span>
        <span>{text}</span>
      </div>
    </div>
  );
};

HoverFlag.propTypes = {
  text: PropTypes.string.isRequired,
  abbr: PropTypes.string,
  className: PropTypes.className,
  inline: PropTypes.bool
};

HoverFlag.defaultProps = {
  abbr: "",
  className: "",
  inline: false
};

export default HoverFlag;



// WEBPACK FOOTER //
// ./app/modules/parts/components/HoverFlag/HoverFlag.jsx